import { PageType } from "@snapchat/web-blizzard-reporting";
import { ConsumerApp } from "@snapchat/web-consumer-nav";
import { generateAttributedDownloadUrl, PageFrame, ResponsiveSSRPage, Shell, } from "@snapchat/web-frame";
import { getCountryFromLocale, useLocale } from "@snapchat/web-i18n";
import { NoContent, Reason } from "@snapchat/web-no-content-page";
import { useGenerateWebPageViewTraceId } from "@snapchat/web-page-view";
import { useCreateOrUpdateWebClientId, useEssentialSession } from "@snapchat/web-sc-cookies";
import { incrementCountsByPageAndCountry } from "@snapchat/web-graphene-reporting";
import { useEffect, useMemo, useRef } from "react";
import { grafanaBasePrefix } from "../../lib/grafana";
import { getBaseShellProps } from "../../lib/shell";
import { loadMessages } from "../../i18n/messages";
/*
 * Generic 451, content not available page.
 */
function ContentUnavailable(props) {
    const pageType = PageType.NOT_AVAILABLE;
    const { locale, messages, changeLocale } = useLocale({
        loadMessages,
    });
    const countryRef = useRef(getCountryFromLocale(locale));
    countryRef.current = useMemo(() => getCountryFromLocale(locale), [locale]);
    useEssentialSession();
    // NOT_AVAILABLE pages are static pages and thus should be treated as requests coming from GDPR countries
    const webClientId = useCreateOrUpdateWebClientId({
        isGdpr: true,
    });
    const { traceId } = useGenerateWebPageViewTraceId();
    useEffect(() => {
        void incrementCountsByPageAndCountry(grafanaBasePrefix, PageType[pageType], 1, countryRef.current);
    }, [pageType]);
    const baseShellProps = useMemo(() => getBaseShellProps(), []);
    return (<Shell isGDPRCountry locale={locale} messages={messages} country={countryRef.current} title="Snapchat" pageMetadata={{ pageType }} webClientId={webClientId} webPageViewTraceId={traceId} {...baseShellProps}>
      <PageFrame disableUpsellQRCode={props.disableUpsellQRCode} webClientId={webClientId} webPageViewTraceId={traceId} locale={locale} localeChange={changeLocale} appType={ConsumerApp.Lens} pageType={pageType} downloadUrl={generateAttributedDownloadUrl(pageType)}>
        <NoContent pageType={pageType} locale={locale} changeLocale={changeLocale} reason={Reason.CONTENT_NOT_AVAILABLE} hideFooter/>
      </PageFrame>
    </Shell>);
}
function ContentUnavailableWrapper(props) {
    return (<ResponsiveSSRPage isMobileServerSide>
      <ContentUnavailable {...props}/>
    </ResponsiveSSRPage>);
}
export { ContentUnavailableWrapper as ContentUnavailable };
